<app-agent-list
  [agents]="agents"
  [copiedAgents]="copiedAgents"
  [agency]="agency"
  [isAddNewAgentAvailable]="false"
  [loaded]="loaded"
  (emitUpdateAgents)="getAgency()"
>
</app-agent-list>
